import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AppToastComponent as ToastComp } from '../../../../services/shared-service/toast-simple/toast.component'

@Component({
  selector: 'app-knockout-setting',
  templateUrl: './knockout-setting.component.html',
  styleUrls: ['./knockout-setting.component.scss']
})
export class KnockoutSettingComponent implements OnInit {
  public isLoading: boolean = false;
  public isGenerateTiming: boolean = false;
  @ViewChild(ToastComp) toastComp: ToastComp;
  @Input() mainObject = {}

  selectedCategory={categoryName: "Category A", categoryCode: "A"}

  categoryList=[  
    {categoryName: "Category A", categoryCode: "A"},
    {categoryName: "Category B", categoryCode: "B"},
    // {categoryName: "Category C", categoryCode: "C"},
    // {categoryName: "Category W", categoryCode: "W"}
  ]
  matches: any[] = [];
  groupsList=[]
  duplicateGroups={}
  constructor( private toastr: ToastrService,) {
    this.toastr.toastrConfig.preventDuplicates = true;
   }

  getListOfGroups=() => {
    let groups=this.mainObject[this.selectedCategory.categoryCode]?.groupsWithTeams?.map(element=>element.name)
    this.groupsList=groups
  }

  ngOnInit() {
    this.getListOfGroups()
    this.generateMatches();
  }

  generateMatches() {
    for (let i = 0; i < this.groupsList.length; i += 2) {
      const match = { player1: this.groupsList[i], player2: (i + 1 < this.groupsList.length) ? this.groupsList[i + 1] : '' };
      this.matches.push(match);
    }
  }

  onCategoryChange = async (event: any) => {
    const selectedCategory=this.categoryList.find(c=>c.categoryCode ===event.target.value)
    this.selectedCategory = selectedCategory;
    this.matches=[]
    this.getListOfGroups()
    if(this.mainObject[this.selectedCategory.categoryCode].matchesDetail)
      this.matches=this.mainObject[this.selectedCategory.categoryCode].matchesDetail
    else
      this.generateMatches();

};

matchSetting=(matchIndex,key,groupName)=>{
  this.matches[matchIndex][key]=groupName
  console.log('this.matches[matchIndex][key]',this.matches[matchIndex][key]);

  if(this.duplicateGroups[groupName]){
    delete this.duplicateGroups[groupName]
  }
  else
    this.duplicateGroups[groupName]=1
}

saveKnockoutSetting=()=>{
  const hasRepeats = this.hasRepeatedValues(this.matches);
  if(hasRepeats)
  {this.toastr.error(`Group repetition not allowed`, );
  return} 

  this.mainObject[this.selectedCategory.categoryCode].matchesDetail=this.matches

  console.log('Blah',this.matches,hasRepeats);
}

hasRepeatedValues=(objArray)=> {
  const seenValues = {};

  for (const obj of objArray) {
      for (const key in obj) {
          const value = obj[key];

          if (value !== "" && seenValues[value]) {
              return true; // Found a repeated value
          }

          seenValues[value] = true;
      }
  }

  return false; // No repeated values found
}

isKnockoutSettingSaved=()=>{
  if(this.mainObject[this.selectedCategory.categoryCode].matchesDetail)
    return true
  return false
}

isKnockoutSettingSavedForAllCategories=()=>{
  for(let category of this.categoryList){
    if(this.mainObject[category.categoryCode]?.matchesDetail?.length>0)
    continue
  else
  return false;
  }
  return true;

}

saveAllKnockoutSetting=()=>{
  console.log('Movingn');
}
}
